"use strict";

module.exports = function (item) {
  return item[0];
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/iterable/first.js
// module id = 558
// module chunks = 37